import React, { useState } from 'react';
import { History } from '@material-ui/icons';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';

import { NOTIFICATIONS } from '../../constants';
import Button from '../Button/Button';

import { ChannelHistoryGrid } from './ChannelHistoryGrid';
import { useChannelHistory } from './hooks/useChannelHistory';

export const ChannelHistory = ({ channelId, createNotification }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [error, loading, history] = useChannelHistory(channelId, modalOpen);

  if (error) {
    createNotification({
      message: `Failed to fetch channel history: ${channelId} `,
      type: NOTIFICATIONS.TYPE.ERROR,
      timeout: 3000,
    });
  }

  const onModalClose = () => {
    setModalOpen(false);
    setSelected(null);
  };

  return (
    <>
      <Button
        type="transparent"
        className="p-0-important shadow-none-important h-6 ml-8"
        onClick={() => setModalOpen(true)}>
        <History className="text-darkGrey" />
      </Button>
      <Dialog
        onClose={onModalClose}
        aria-labelledby="opening-hour-history-title"
        maxWidth={'md'}
        fullWidth={true}
        open={modalOpen}>
        <DialogTitle id="opening-hour-history-title">History</DialogTitle>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          style={{ height: '25rem', margin: '0rem 1rem 3rem 1rem' }}>
          {loading && <CircularProgress />}
          {!loading && (
            <ChannelHistoryGrid
              history={history}
              selected={selected}
              setSelected={setSelected}
            />
          )}
        </Box>
      </Dialog>
    </>
  );
};
